import { render, staticRenderFns } from "./certificate-list.vue?vue&type=template&id=75f2dd49&scoped=true&"
import script from "./certificate-list.vue?vue&type=script&lang=js&"
export * from "./certificate-list.vue?vue&type=script&lang=js&"
import style0 from "./certificate-list.vue?vue&type=style&index=0&id=75f2dd49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f2dd49",
  null
  
)

export default component.exports